import React from "react";
import { NavLink } from "react-router-dom";
import officialLogo from "../assets/logo.png";
import favicon from "../assets/favicon.ico";

const SidebarTop = ({ isOpen }) => {
  return (
    <div className={`flex items-center justify-center border-b border-gray-200/80 bg-white ${isOpen ? "p-3 h-16" : "p-3 h-16"} transition-all duration-300`}>
      <NavLink to="/dashboard">
        {isOpen ? (
          <img
            src={officialLogo}
            alt="Official Logo"
            className="transition-all duration-500 ease-in-out w-36 hover:scale-105"
          />
        ) : (
          <img
            src={favicon}
            alt="Placeholder Logo"
            className="transition-all duration-500 ease-in-out h-7 w-12 hover:scale-105"
          />
        )}
      </NavLink>
    </div>
  );
};

export default SidebarTop;